module.exports = __webpack_public_path__ + "static/media/galerija_2019 (25).300815b4.jpg";